import React, { useState } from 'react';
import { Autocomplete } from '@material-ui/lab';
import { TextField } from '@material-ui/core';

import useCitySearch from '../../../../../../hooks/useCitySearch';

export default function CityField({ city, stateUF = '', onChangeCity }) {
  const {cities, isLoading} = useCitySearch({ stateUF });

  const [search, setSearch] = useState('');
  
  return (
    <Autocomplete
      clearOnEscape
      selectOnFocus
      handleHomeEndKeys
      options={cities}
      loading={isLoading}
      value={city}
      inputValue={search}
      disabled={!stateUF}
      noOptionsText="Nenhuma cidade encontrada. Selecione o estado"
      onInputChange={(event, newValue) => setSearch(newValue)}
      onChange={(event, newValue) => onChangeCity(newValue)}
      getOptionSelected={(option, value) => option === value}
      getOptionLabel={state => state ? `${state}` : ''}
      renderInput={(params) => (
        <TextField {...params} label="Cidade" />
      )}
    />
  );
}